import React, { FC } from 'react'

import { UpsellItem } from 'public/components/default_template/online_ordering/upsell/UpsellItem'
import { getUpsellItemPrice } from 'public/components/default_template/online_ordering/upsell/utils/upsellUtils'

interface UpsellBasicCardProps {
  item?: UpsellItem
  onItemSelect: () => void
}

export const UpsellBasicCard: FC<UpsellBasicCardProps> = (
  props: UpsellBasicCardProps
) => {
  const { item, onItemSelect } = props

  if (!item) {
    return <></>
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.code === 'Enter' || e.code === 'Space') {
      onItemSelect()
    }
  }

  return (
    <div
      role='button'
      className='basicUpsellCardGrid'
      data-testid='UpsellBasicCard'
      onClick={onItemSelect}
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <p className='title'>{item.name}</p>
      <div className='price'>
        {getUpsellItemPrice(item)}
        <div className='upsellQuickAddBtn' aria-hidden>
          +
        </div>
      </div>
    </div>
  )
}
